import { Locale as DateFnsLocale } from 'date-fns';
import { enUS, nl } from 'date-fns/locale';
import i18next from 'i18next';

const dateFnsLocales: Record<string, DateFnsLocale> = {
  en: enUS,
  nl: nl,
};

export type CurrencyCode = 'EUR' | 'GBP' | 'USD';
export type Locale = 'nl-NL' | 'en-GB' | 'en-US';

export function currencyCodeToLocale(currencyCode: CurrencyCode) {
  const currencyLocaleMap: Record<CurrencyCode, Locale> = {
    EUR: 'nl-NL',
    GBP: 'en-GB',
    USD: 'en-US',
  };

  return currencyLocaleMap[currencyCode.toUpperCase()] || 'nl-NL';
}

export function localeToCurrencyCode(locale: Locale): CurrencyCode {
  const currencyCodeMap: Record<Locale, CurrencyCode> = {
    'nl-NL': 'EUR',
    'en-GB': 'GBP',
    'en-US': 'USD',
  };

  return currencyCodeMap[locale] || 'EUR';
}

export const localizedNumber = ({
  value,
  locale = 'nl-NL',
  fractionDigits = 2,
  unitLabel,
  options = {},
}: {
  value?: number | string | null;
  locale?: Locale;
  fractionDigits?: number;
  unitLabel?: string;
  options?: Intl.NumberFormatOptions;
}) => {
  if (value === '' || value === null || value === undefined) {
    return '-';
  }

  if (isNaN(+value)) {
    return 'NaN';
  }

  const formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    ...options,
  }).format(+value);

  return unitLabel ? `${formattedNumber} ${unitLabel}` : formattedNumber;
};

export const localizedPrice = ({ value, locale = 'nl-NL' }: { value?: number | string | null; locale?: Locale }) => {
  return localizedNumber({ value, locale, options: { style: 'currency', currency: localeToCurrencyCode(locale) } });
};

export const getDateLocale = () => {
  const language = i18next.language;
  return dateFnsLocales[language] ?? dateFnsLocales.en;
};
